//imports
import {
    MANUFACTURERS_OVERVIEW_GET_DATA_REQUEST,
    MANUFACTURERS_OVERVIEW_GET_DATA_RESULT,
    CLEAR_REDUX,
} from "Redux/actionTypes";

//initial values
const INIT_STATE = {
    loading: false,
    manufacturer: null,
};

//change redux object
export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case MANUFACTURERS_OVERVIEW_GET_DATA_REQUEST:
            return { ...state, loading: true };

        case MANUFACTURERS_OVERVIEW_GET_DATA_RESULT:
            return { ...state, loading: false, manufacturer: action.payload };

        case CLEAR_REDUX:
            return ["", "MANUFACTURER_OVERVIEW"].includes(action.payload.option)
                ? action.payload.parameters
                    ? { ...state, ...action.payload.parameters }
                    : { ...INIT_STATE }
                : { ...state };

        default:
            return state;
    }
};
